import { Entity } from '@backstage/catalog-model';
import { Flex, Grid, Text } from '@backstage/ui';
import { CardVariant, TechDocsCard } from '@internal/backstage-plugin-hm-react';

export type Group = {
  title: React.ReactNode;
  filterPredicate: (entity: Entity) => boolean;
  cardVariant?: CardVariant;
  withoutTags?: boolean;
  withoutLinks?: boolean;
};

export type DocsGridProps = {
  entities: Entity[];
  groups?: Group[];
};

export const DocsGrid = ({ entities, groups }: DocsGridProps) => {
  if (!groups || groups.length === 0) {
    return (
      <Grid.Root columns={{ initial: '1', sm: '2', md: '3', lg: '5' }} gap="3">
        {entities.map(entity => (
          <Grid.Item key={entity.metadata.uid ?? entity.metadata.name}>
            <TechDocsCard entity={entity} fullHeight />
          </Grid.Item>
        ))}
      </Grid.Root>
    );
  }

  return (
    <>
      {groups.map((group, index) => {
        const groupEntities = entities.filter(group.filterPredicate);
        if (groupEntities.length === 0) return null;

        const groupKey =
          typeof group.title === 'string' || typeof group.title === 'number'
            ? String(group.title)
            : `group-${index}`;

        const variant = group.cardVariant ?? CardVariant.normal;
        const isMinimal = variant === CardVariant.minimal;

        return (
          <Flex key={groupKey} direction="column" gap="2">
            {group.title ? (
              <Text variant="title-x-small">{group.title}</Text>
            ) : null}
            <Grid.Root
              columns={{ initial: '1', sm: '2', md: '3', lg: '5' }}
              gap="3"
            >
              {groupEntities.map(entity => (
                <Grid.Item key={entity.metadata.uid ?? entity.metadata.name}>
                  <TechDocsCard
                    entity={entity}
                    actionable={isMinimal ? true : undefined}
                    withoutTheme={isMinimal ? true : undefined}
                    withoutTags={group.withoutTags}
                    withoutLinks={group.withoutLinks}
                    variant={isMinimal ? variant : undefined}
                    fullHeight
                  />
                </Grid.Item>
              ))}
            </Grid.Root>
          </Flex>
        );
      })}
    </>
  );
};
